module.exports = __webpack_public_path__ + "static/media/header-bg.8d512e99.jpg";